<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div>
                    <SemPermissao></SemPermissao>
                </div>
            </div>
            <template v-if="!erro">
                <RespostaForm :resposta="resposta" />
            </template>
        </div>
    </div>
</template>

<script>

    import RespostaForm from "../../components/respostas/RespostaForm.vue"
    import RespostaApi from "../../services/RespostaApi"
    import SemPermissao from "../SemPermissao.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "RespostaEdit",
        metaInfo() {
            if (!this.resposta) {
                return {};
            }
            let title = this.resposta.texto;
            const description = this.resposta.texto;

            return {
                title,
                titleTemplate: "Editar %s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                resposta: null,
            };
        },
        components: {
            SemPermissao,
            RespostaForm,
        },
        created() {
            this.respostaApi = new RespostaApi();
            this.carregarResposta();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarResposta();
                }
            },
        },
        methods: {
            carregarResposta: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.respostaApi.cancelTokens.getResposta) {
                        this.respostaApi.cancelTokens.getResposta.cancel();
                    }

                    const dadosResposta = await this.respostaApi.getResposta(
                        this.$route.params.id
                    );
                    this.resposta = dadosResposta;

                    this.carregando = false;
                } catch (err) {
                    if (this.respostaApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.resposta = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>